import React from 'react'
import PropTypes from 'prop-types'
import PlaylistRow from './PlaylistRow'
import CreateNewPlaylistModal from './modals/CreateNewPlaylistModal'

import './PlaylistSelector.scss'
import PlaylistLoadingCards from './PlaylistLoadingCards'
import { Dropdown } from 'ui/bend'
import styled from 'styled-components'
import { Caption } from 'ui/bend'
import css from '@styled-system/css'

import { PlusIcon } from 'images/latest'

const DropDownWrapper = styled(Caption)(() =>
  css({
    display: 'flex',
    fontSize: '18px',
    letterSpacing: '0.396px',
    color: '#636363',
    alignItems: 'center',
    gap: '16px',
    ':nth-child(1)': {
      width: '290px'
    },
    label: {
      fontSize: ['16px' , '18px'],
      fontWeight: '400'
    }
  })
)

class PlaylistSelector extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      modalOpen: false
    }
  }

  selectEvent = ({ uuid }) => {
    const playlist = this.props.playlists.find((item) => item.uuid === uuid)
    this.props.onSelect(playlist)
  }

  isMobile = () => {
    const width = document?.body?.clientWidth
    return width <= 768 ? true : false
  }

  render() {
    const dropDownList = this.props.playlists.reduce((playlists, item) => {
      return [
        {
          label: item.title,
          value: item.uuid,
          uuid: item.uuid,
          isActive: this.props.isActive(item)
        },
        ...playlists
      ]
    }, [])
    const activeUuid = dropDownList.find((item) => item.isActive)?.uuid
    let playlists = this.props.playlists.map((playlist) => {
      return (
        <PlaylistRow
          playlist={playlist}
          onSelect={this.props.onSelect}
          marked={this.props.isMarked(playlist)}
          active={this.props.isActive(playlist)}
          key={playlist.uuid}
        />
      )
    })
    const formattedTime = new Date()

    return (
      <div className='PlaylistSelector'>
        {this.props.loading ? (
          <PlaylistLoadingCards />
        ) : (
          <DropDownWrapper>
            <label>Select</label>
            <Dropdown
              width={this.isMobile() ? '210px' : '225px'}
              items={dropDownList}
              onChange={this.selectEvent}
              value={activeUuid}
            />
          </DropDownWrapper>
        )}
        <div
          className='PlaylistSelector__new'
          onClick={() => {
            this.setState({ modalOpen: true })
          }}
        >
          {this.isMobile() ? (
            <>
              <PlusIcon />
              New
            </>
          ) : (
            'New Playlist'
          )}
        </div>

        <CreateNewPlaylistModal
          active={this.state.modalOpen}
          onHide={(uuid) => {
            this.setState({ modalOpen: false })
            if (uuid) this.props.onPlaylistAdded(uuid)
          }}
        />
      </div>
    )
  }
}

PlaylistSelector.defaultProps = {
  isMarked: () => {
    return false
  },
  isActive: () => {
    return false
  },
  playlists: []
}

PlaylistSelector.propTypes = {
  isMarked: PropTypes.func,
  onSelect: PropTypes.func,
  playlists: PropTypes.array,
  loading: PropTypes.bool,
  isActive: PropTypes.func,
  onPlaylistAdded: PropTypes.func,
  onReordered: PropTypes.func,
  sortable: PropTypes.bool
}

export default PlaylistSelector
